export function octetsToMo(octets: number): number {
  return octets / 1000 / 1000;
}
